const deliveryConfirmationEN = {
    "view": {
        "table": {
            "title": "Delivered List",
            "columns": {
                "release": "Release",
                "upc": "UPC Number",
                "action": "Action",
                "status": "Status",
                "deliveryDate": "Delivery Date",
                "details": "Details"
            },
            "label": {
                "statusDelivered": "DELIVERED",
                "statusPartially": "PARTIALLY",
                "statusUndelivered": "UNDELIVERED",
                "ddexActionInsert": "INSERT",
                "ddexActionFullUpdate": "FULL UPDATE",
                "ddexActionMetadataUpdate": "META. UPDATE",
                "ddexActionTakedown": "TAKEDOWN"
            },
            "placeholder": {
                "search": "Search..."
            },
            "button": {
                "open": "OPEN",
                "exportCSV": "Export CSV"
            }
        }
    },
    "breakdownView": {
        "table": {
            "title": "Store Delivery List",
            "column": {
                "store": "Store",
                "additionalNote": "Additional Notes",
                "status": "Status",
            },
            "label": {
                "statusDelivered": "DELIVERED",
                "statusUndelivered": "UNDELIVERED"
            },
            "button": {
                "exportCSV": "Export CSV"
            },
            "message": {
                "appleSubjectToQC": "Successfully delivered, subject to additional QC control by Apple Music staff.",
                "releaseDeliverySuccessfull": "Release has been successfully delivered to the {{dspName}} servers",
                "releaseDeliveryUnsuccessfull": "Release delivery was unsuccessfull for {dspName}.",
                "noDeliveriesPossible": "No deliveries possible at the moment"
            }
        }
    }
};

export default deliveryConfirmationEN;